import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { CommonFunctions } from "src/app/CommonComponent/function/commonfunctions";
import { constantUrl } from "src/app/Shared/constantUrl";
declare var $: any;
@Component({
  selector: "app-key-facts-statement",
  templateUrl: "./key-facts-statement.component.html",
  styleUrls: ["./key-facts-statement.component.scss"],
})
export class KeyFactsStatementComponent implements OnInit {

  @Input() loanId: any;

  Item1Data: any = {};
  Item2Data: any = {};
  Item3Data: any = {};
  Item4Data: any = {};
  Item5Data: any[] = [];

  currentUser: any;
  totalDRAmount = 0;
  totalCRAmount = 0;
  diffCRandDR = 0;
  disbursementType: any;

  logoBase64: string = '';

  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;

  constructor(
    private _commonfunctions: CommonFunctions,
    private lmsService: LmsService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getKFSData();
  }

  private convertImageToBase64(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx?.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = (err) => {
        console.error("Logo load failed", err);
        reject(err);
      };
      img.src = url;
    });
  }

getKFSData() {
  this.lmsService
    .Get_KFS_Statement({ loanId: this.loanId })
    .subscribe((res: any) => {

      this.Item1Data = res?.Item1[0];
      this.Item2Data = res?.Item2;
      this.Item3Data = res?.Item3;
      this.calculateTotalAmounts();
      this.Item4Data = res?.Item4;
      this.Item5Data = res?.Item5;

      this.disbursementType = res?.Item4[0]?.DisbursmentType;

      this.loadLogoAsBase64();
    });
}
loadLogoAsBase64() {
  const logoUrl = `${this.EmployeeProfileBaseUrl}logo.png`;

  this.http.get(logoUrl, { responseType: 'blob' }).subscribe(
    (blob: Blob) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1];
        this.logoBase64 = base64String;  
        
      };
      reader.onerror = () => {
        console.error("❌ Failed to read logo as base64");
        this.logoBase64 = '';
      };
      reader.readAsDataURL(blob);
    },
    (err) => {
      console.error("❌ Failed to fetch logo", err);
      this.logoBase64 = '';
    }
  );
}
  calculateTotalAmounts() {
    this.totalDRAmount = 0;
    this.totalCRAmount = 0;
    this.Item3Data.forEach((item) => {
      this.totalDRAmount += parseFloat(item.DRAmount || 0);
      this.totalCRAmount += parseFloat(item.CRAmount || 0);
    });
    this.diffCRandDR = this.totalCRAmount - this.totalDRAmount;
  }

  viewKFSstatement() {
    this.getKFSData();
    $("#viewKeyFactsStatementAnnexA").modal("show");
    $("#viewKeyFactsStatementAnnexA").css("z-index", "1050");
  }

  onCloseKeyFactsStatement() {
    $("#viewKeyFactsStatementAnnexA").modal("hide");
  }

  onDocsPrint(divName, Header) {
    this._commonfunctions.PrintDocuments(divName, Header, "");
  }
}